export default "__VITE_ASSET__MRkEv5HH__"